<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <div v-if="openKeepAlive">
        <keep-alive :include="cachedViews">
          <router-view :key="key"/>
        </keep-alive>
      </div>
      <div v-else>
        <router-view :key="key"/>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews () {
      return this.$store.state.tagsView.cachedViews
    },
    key () {
      return this.$route.fullPath
    },
    openKeepAlive () {
      return this.$route.meta.keepAlive
    }
  }
}
</script>

<style scoped>
  .app-main {
    min-height: calc(100vh - 84px);
    position: relative;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/Layout/components/AppMain.vue